/**
 * 判断当前是否运行在 Electron 环境中
 * @returns {boolean} 返回 true 表示在 Electron 中，false 表示在网页端
 */
const isElectron = () => {
    // 方法 1: 检查 process.versions.electron
    if (typeof process !== 'undefined' && process.versions && process.versions.electron) {
        return true;
    }

    // 方法 2: 检查 window.process 和 window.process.type
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
        return true;
    }

    // 方法 3: 检查 window.require (Electron 的 require)
    if (typeof window !== 'undefined' && typeof window.require === 'function') {
        try {
            const { ipcRenderer } = window.require('electron');
            if (ipcRenderer) {
                return true;
            }
        } catch (e) {
            // 如果 require('electron') 失败，说明不在 Electron 环境中
        }
    }

    // 如果以上条件都不满足，说明在网页端
    return false;
};

/**
 * 获取当前运行环境
 * @returns {string} 返回 'electron' 或 'web'
 */
const getEnvironment = () => {
    return isElectron() ? 'electron' : 'web';
};

// 导出方法
export { isElectron, getEnvironment };
